/* eslint-disable @typescript-eslint/no-explicit-any */
import { Store } from "@ngrx/store";
import { AppActions, FromRouter, FromUser, ProgramActions, RootState, UserActions } from "./store";
import { first, tap } from "rxjs";
import { AppStore } from "./store/app-signal/app.store";
import { inject } from "@angular/core";

export const initializeApp =
  (store: Store<RootState>): any =>
  () => {
    try {
      const origin = window.location.origin;
      const appStore = inject(AppStore);
      appStore.setOrigin(origin);

      store
        .select(FromUser.selectUserId)
        .pipe(
          first(userId => !!userId),
          tap(userId => {
            store.dispatch(UserActions.getUserData({ userId }));
          }),
        )
        .subscribe();

      store
        .select(FromRouter.selectProgramId)
        .pipe(
          first(programId => !!programId),
          tap(programId => {
            store.dispatch(ProgramActions.getConfig({ programId }));
          }),
        )
        .subscribe();

      store.dispatch(AppActions.setOrigin({ origin }));

      store
        .select(FromRouter.selectSkipTeaser)
        .pipe(
          first(skipTeaser => !!skipTeaser),
          tap(skipTeaser => store.dispatch(AppActions.setWorkflowSkipTeaser({ skipTeaser: skipTeaser === "true" }))),
        )
        .subscribe();
    } catch {}
  };
